import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useTestId } from "@/hooks";
export const Feature = ({ feature }) => {
    const testId = useTestId("Sections.Features.Feature");
    return (_jsxs(Box, { display: "flex", gap: "spacing.12", testId: testId, children: [feature.Icon, _jsx(Box, { as: "span", whiteSpace: "wrap", children: feature.value })] }));
};
